export default "__VITE_ASSET__3Z5SnQFz__"